/**
 * Basic dialog implementation.
 */
import { PropsWithChildren, useCallback } from "react";
import { className as classNames } from "utils/strings";

import { ReactComponent as BackIcon } from "components/icons/left_arrow.svg";
import { ReactComponent as CloseIcon } from "components/icons/close.svg";

import "./Dialog.scss";

type IDialogProps = PropsWithChildren<{
  onBack?: () => void;
  onClose?: () => void;
  title: string;
  buttons?: JSX.Element;
  className?: string;
}>;

export const Dialog = ({ onBack, onClose, title, children, buttons, className }: IDialogProps): JSX.Element => {
  const handleBack = useCallback(() => {
    onBack && onBack();
  }, [onBack]);

  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return (
    <div className={classNames({
      "dialog": true,
      [className ?? ""]: true,
    })}>
      <div className="backdrop"></div>
      <div className="canvas">
        <div className="dialogHeader">
          { onBack && (
            <button className="back button" onClick={handleBack}>
              <BackIcon />
            </button>
          )}

          <div className="dialogTitle">{title}</div>

          { onClose && (
            <button className="close button" onClick={handleClose}>
              <CloseIcon />
            </button>
          )}
        </div>

        <div className="dialogContent">
          {children}
        </div>

        { buttons && (
          <div className="dialogButtons">
            {buttons}
          </div>
        )}
      </div>
    </div>
  );
};
